import { createAction } from "redux-act";
import { create } from "lodash";

// Can Browse With No Account
export const browseUnauthenticated = createAction("browseUnauthenticated");

// Notification Center
export const pushNotification = createAction("pushNotification");
export const cleanNotifications = createAction("cleanNotifications");

// Jumio
export const uploadToJumio = createAction("uploadToJumio");

// Terms Version
export const getTermsVersion = createAction("getTermsVersion");
export const fillTermsVersion = createAction("fillTermsVersion");
export const fillAcceptNewTerms = createAction("fillAcceptNewTerms");
export const rejectTerms = createAction("rejectTerms");
export const fillTemporaryAcc = createAction("fillTemporaryAcc");
export const cleanTemporaryAcc = createAction("cleanTemporaryAcc");
export const requestAcceptNewTerms = createAction("requestAcceptNewTerms");

// User API
export const requestSignIn = createAction("requestSignIn");
export const getAccount = createAction("getAccount");
export const fillAccount = createAction("fillAccount");
export const signUpRequest = createAction("signUpRequest");
export const handleSignUpRequest = createAction("handleSignUpRequest");
export const updateAccount = createAction("updateAccount");
export const fetchTerritories = createAction("fetchTerritories");
export const fillTerritories = createAction("fillTerritories");
export const showIPForm = createAction("showIPForm");
export const submitIpConfirmation = createAction("submitIpConfirmation");
export const fillIpConfirmation = createAction("fillIpConfirmation");
export const requestSignOut = createAction("requestSignOut");
export const fillLoginError = createAction("fillLoginError");

// UAC API
export const fetchCountries = createAction("fetchCountries");
export const fillCountries = createAction("fillCountries");
export const fetchNationalities = createAction("fetchNationalities");
export const fillNationalities = createAction("fillNationalities");
export const fetchOccupations = createAction("fetchOccupations");
export const fillOccupations = createAction("fillOccupations");

// API keys
export const requestApiKey = createAction("requestApiKey");
export const fillNewApiKey = createAction("fillNewApiKey");
export const fetchApiKeys = createAction("fetchApiKeys");
export const fillApiKeys = createAction("fillApiKeys");
export const deleteApiKey = createAction("deleteApiKey");
export const cleanNewApiKey = createAction("cleanNewApiKey");
export const fetchApiSummary = createAction("fetchApiSummary");
export const fillApiSummary = createAction("fillApiSummary");

// Password
export const submitChangePassword = createAction("submitChangePassword");
export const requestPasswordReset = createAction("requestPasswordReset");
export const completePasswordReset = createAction("completePasswordReset");
export const passwordResetInitiated = createAction("passwordResetInitiated");
export const passwordResetComplete = createAction("passwordResetComplete");

// OTP
export const disableOtp = createAction("disableOtp");
export const enableOtp = createAction("enableOtp");
export const fillOtpSecret = createAction("fillOtpSecret");
export const cleanOtpSecret = createAction("cleanOtpSecret");
export const fillOtpEnabled = createAction("fillOtpEnabled");
export const fillOtpDisabled = createAction("fillOtpDisabled");

// Document Centre
export const uploadFile = createAction("uploadFile");
export const fileUploaded = createAction("fileUploaded");

// Verification Screen
export const showVerificationScreen = createAction("showVerificationScreen");
export const continueVerification = createAction("continueVerification");

// Email Verification
export const submitVerificationCode = createAction("submitVerificationCode");
export const fillVerificationResponse = createAction(
  "fillVerificationResponse"
);
export const resendVerificationCode = createAction("resendVerificationCode");

export const emailVerificationError = createAction("emailVerificationError");
export const fillResendEmailCode = createAction("fillResendEmailCode");
export const cleanEmailCodeResent = createAction("cleanEmailCodeResent");

// Phone Verification
export const fetchPhoneCodes = createAction("fetchPhoneCodes");
export const fillPhoneCodes = createAction("fillPhoneCodes");
export const verifyPhone = createAction("verifyPhone");
export const fillPhoneResponse = createAction("fillPhoneResponse");
export const cleanPhoneResponse = createAction("cleanPhoneResponse");

// Profile Submission
export const submitProfile = createAction("submitProfile");
export const fillProfileResponse = createAction("fillProfileResponse");
export const cleanProfileResponse = createAction("cleanProfileResponse");

// ID Verification
export const getAcceptedIDtypes = createAction("getAcceptedIDtypes");
export const fillIDtypes = createAction("fillIDtypes");
export const uploadJumioFinished = createAction("uploadJumioFinished");
export const uploadLevel6finished = createAction("uploadJLevel6finished");

// Address Verification
export const updateProfile = createAction("updateProfile");

// Theme & Language
export const getLang = createAction("getLang");
export const setNewLang = createAction("setNewLang");

// Clean Actions
export const cleanSearch = createAction("cleanSearch");
export const cleanSingleInfo = createAction("cleanSingleInfo");
export const cleanTerritories = createAction("cleanTerritories");

// Institutions
export const fetchInstitution = createAction("fetchInstitution");
export const fillInstitution = createAction("fillInstitution");
export const createInstitution = createAction("createInstitution");
export const submitBankDetails = createAction("submitBankDetails");
export const submitInstitutionDirectors = createAction(
  "submitInstitutionDirectors"
);
export const submitInstitutionOwners = createAction("submitInstitutionOwners");
export const submitInstitutionDocuments = createAction(
  "submitInstitutionDocuments"
);

// SIMILAR PROFILE
export const similarProfileToggle = createAction("similarProfileToggle");

export const sagasActions = {
  requestSignIn,
  getAccount,
  fillAccount,
  signUpRequest,
  handleSignUpRequest,
  verifyPhone,
  fillPhoneResponse,
  submitProfile,
  fillProfileResponse,
  getAcceptedIDtypes,
  fillIDtypes,
  pushNotification,
  uploadFile,
  updateAccount,
  enableOtp,
  disableOtp,
  fillOtpSecret,
  submitChangePassword,
  uploadToJumio,
  fetchTerritories,
  fillTerritories,
  updateProfile,
  requestApiKey,
  fillNewApiKey,
  fetchApiKeys,
  fillApiKeys,
  deleteApiKey,
  resendVerificationCode,
  submitVerificationCode,
  requestPasswordReset,
  completePasswordReset,
  passwordResetInitiated,
  passwordResetComplete,
  fillVerificationResponse,
  showIPForm,
  submitIpConfirmation,
  fillIpConfirmation,
  requestSignOut,
  emailVerificationError,
  fillResendEmailCode,
  similarProfileToggle,
  fillOtpEnabled,
  fillOtpDisabled,
  fillTermsVersion,
  getTermsVersion,
  fillAcceptNewTerms,
  fillTemporaryAcc,
  requestAcceptNewTerms,
  fileUploaded,
  fillLoginError,
  fetchCountries,
  fillCountries,
  fetchNationalities,
  fillNationalities,
  fetchOccupations,
  fillOccupations,
  uploadLevel6finished,
  uploadJumioFinished,
  fetchPhoneCodes,
  fillPhoneCodes,
  fetchInstitution,
  fillInstitution,
  submitBankDetails,
  submitInstitutionDirectors,
  submitInstitutionOwners,
  submitInstitutionDocuments,
  createInstitution,
  fetchApiSummary,
  fillApiSummary,
};

export const reduxActions = {
  getLang,
  setNewLang,
  handleSignUpRequest,
  showVerificationScreen,
  fillPhoneResponse,
  cleanPhoneResponse,
  fillProfileResponse,
  cleanProfileResponse,
  fillIDtypes,
  pushNotification,
  cleanNotifications,
  cleanOtpSecret,
  fillOtpSecret,
  continueVerification,
  fillTerritories,
  fillAccount,
  fillNewApiKey,
  fillApiKeys,
  passwordResetInitiated,
  passwordResetComplete,
  fillVerificationResponse,
  showIPForm,
  fillIpConfirmation,
  requestSignOut,
  cleanNewApiKey,
  emailVerificationError,
  fillResendEmailCode,
  cleanEmailCodeResent,
  similarProfileToggle,
  fillOtpEnabled,
  fillOtpDisabled,
  fillTermsVersion,
  fillAcceptNewTerms,
  rejectTerms,
  fillTemporaryAcc,
  cleanTemporaryAcc,
  fileUploaded,
  fillLoginError,
  fillCountries,
  fillNationalities,
  fillOccupations,
  uploadLevel6finished,
  uploadJumioFinished,
  fillPhoneCodes,
  cleanTerritories,
  fillInstitution,
  fillApiSummary,
};
